import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { server_API } from "../config";
import job_white from "../images/Work_white.png";
import candidate from "../images/candidate_white.png";
import video from "../images/video.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  Filler,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import increase from "../images/increase.png";
import decrease from "../images/decrease.png";
import { useSelector, useDispatch } from "react-redux";
import {
  companyIdSlice,
  updateCompanyId,
  selectCid,
} from "../features/companyid";
import arrow from "../images/arrow_purple.png";
import ReactStars from "react-stars";
import { ApexOptions } from "apexcharts";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import TextToSpeech from "./TextToSpeech";
import { selectUuid, updateInternalSource, updateSpecialTab } from "../features/userid";
import axiosInstance from "../axiosInstance";

//add two graphs with jobs in one graph and

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  Filler
);

const Homepage = () => {
  const [companyUuid, setCompanyUuid] = useState("");
  const [jobs, setJobs] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [applicants, setApplicants] = useState([]);
  const [img, setImg] = useState("");
  const [openJobs, setOpenJobs] = useState(0);
  const [thisMonthData, setThisMonthData] = useState({});
  const [previousMonthData, setPreviousMonthData] = useState({});
  const [openJobsLastMonth, setOpenJobsLastMonth] = useState(0);
  const chart = useRef(null);
  const [pausedJobs, setPausedJobs] = useState(0);
  const [flag, setFlag] = useState(false);
  const [latestJobPosting, setLatestJobPosting] = useState([]);
  const [closedJobs, setClosedJobs] = useState(0);
  const [submissions, setSubmissions] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [interviews, setInterviews] = useState([]);
  const [activeInterviews, setActiveInterviews] = useState([]);
  const [evaluated, setEvaluated] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [totalapplication, setTotalApplication] = useState([]);
  const [graphJobs, setgraphJobs] = useState([]);
  const [eva, setEva] = useState([]);
  // const [interviews, setInterviews] = useState([])
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [sortBy, setSortBy] = useState(() => {
    const savedSortBy = localStorage.getItem("Sort By");

    return savedSortBy || "week";
  });
  const [thisWeek, setThisWeek] = useState([]);
  const [stars, setStars] = useState([]);
  const [sumStars, setSumStars] = useState(0);
  const [lastWeek, setLastWeek] = useState([]);
  const [dept, setDept] = useState([]);
  const [sevenDays, setSevenDays] = useState(0);
  const [thirtyDays, setThirtyDays] = useState(0);
  const [sixtyDays, setSixtyDays] = useState(0);
  const [label, setLabel] = useState([]);
  const [ninetyDays, setNinetyDays] = useState(0);
  const [sFlag, setSFlag] = useState(false);
  const [dateArray, setDateArray] = useState([]);
  const [testDateArray, setTestDateArray] = useState([]);
  const [weekLabel, setWeekLabel] = useState([]);
  const [applicationsMonthly, setApplicationsMonthly] = useState([]);
  const [interviewedMonthly, setInterviewedMonthly] = useState([]);
  const [lastMonth, setLastMonth] = useState([]);
  const cid = useSelector(selectCid);
  const uuid = useSelector(selectUuid);
  const dispatch = useDispatch();

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  useEffect(() => {
    // Save the current value of sortBy to local storage whenever it changes
    localStorage.setItem("sortBy", sortBy);
  }, [sortBy]);

  const mixedChart = {
    series: [
      {
        name: "Applications",
        type: "column",
        data: applicationsMonthly,
      },
      {
        name: "Interviewed",
        type: "line",
        data: interviewedMonthly,
      },
    ],
    options: {
      colors: ["#538EC9", "#FCC523"],
      chart: {
        height: 350,
        type: "line",
      },
      stroke: {
        width: [0, 4],
      },

      dataLabels: {
        enabled: false,
        enabledOnSeries: [],
      },
      labels: sortBy == "week" ? weekLabel : dateArray,
      xaxis: {
        type: "string",
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y) {
            if (typeof y !== "undefined") {
              return y.toFixed(0);
            }
            return 0;
          },
        },
      },
    },
  };

  // const mixedChart = {
  //   series: [{
  //     name: 'TEAM A',
  //     type: 'column',
  //     data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
  //   }, {
  //     name: 'TEAM B',
  //     type: 'area',
  //     data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
  //   }, {
  //     name: 'TEAM C',
  //     type: 'line',
  //     data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
  //   }],
  //   options: {
  //     chart: {
  //       height: 350,
  //       type: 'line',
  //       stacked: false,
  //     },
  //     stroke: {
  //       width: [0, 2, 5],
  //       curve: 'smooth'
  //     },
  //     plotOptions: {
  //       bar: {
  //         columnWidth: '50%'
  //       }
  //     },

  //     fill: {
  //       opacity: [0.85, 0.25, 1],
  //       gradient: {
  //         inverseColors: false,
  //         shade: 'light',
  //         type: "vertical",
  //         opacityFrom: 0.85,
  //         opacityTo: 0.55,
  //         stops: [0, 100, 100, 100]
  //       }
  //     },
  //     labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003',
  //       '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'
  //     ],
  //     markers: {
  //       size: 0
  //     },
  //     xaxis: {
  //       type: 'datetime'
  //     },
  //     yaxis: {
  //       title: {
  //         text: 'Points',
  //       },
  //       min: 0
  //     },
  //     tooltip: {
  //       shared: true,
  //       intersect: false,
  //       y: {
  //         formatter: function (y) {
  //           if (typeof y !== "undefined") {
  //             return y.toFixed(0) + " points";
  //           }
  //           return y;

  //         }
  //       }
  //     }
  //   },

  // };

  const todayDate = new Date();
  useEffect(() => {
    const arr = [];
    const test_arr = [];
    const last_month = [];
    const this_week = [];
    const label_week = [];
    const last_week = [];
    for (let index = 0; index < 30; index++) {
      const start = new Date();
      let dat = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate() - index
      );
      let loclString = dat.toLocaleDateString();
      let normalString = dat.getDate() + "/" + (dat.getMonth() + 1);
      let formattedString =
        dat.getFullYear() +
        "-" +
        padWithLeadingZeros(dat.getMonth() + 1, 2) +
        "-" +
        padWithLeadingZeros(dat.getDate(), 2);
      test_arr.push(formattedString);
      arr.push(normalString);
    }

    for (let index = 0; index < 30; index++) {
      const start = new Date(test_arr.slice(-1));
      let dat = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate() - index
      );
      let loclString = dat.toLocaleDateString();
      let normalString = dat.getDate() + " " + labels[dat.getMonth()];
      let formattedString =
        dat.getFullYear() +
        "-" +
        padWithLeadingZeros(dat.getMonth() + 1, 2) +
        "-" +
        padWithLeadingZeros(dat.getDate(), 2);
      last_month.push(formattedString);
      // arr.push(normalString)
    }

    for (let index = 0; index < 7; index++) {
      const start = new Date();
      let dat = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate() - index
      );
      let loclString = dat.toLocaleDateString();
      let normalString = dat.getDate() + " " + labels[dat.getMonth()];
      let formattedString =
        dat.getFullYear() +
        "-" +
        padWithLeadingZeros(dat.getMonth() + 1, 2) +
        "-" +
        padWithLeadingZeros(dat.getDate(), 2);
      this_week.push(formattedString);
      label_week.push(normalString);
    }

    for (let index = 0; index < 7; index++) {
      const start = new Date(thisWeek.slice(-1));
      let dat = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate() - index
      );
      let loclString = dat.toLocaleDateString();
      let normalString =
        loclString.split("/")[0] + "/" + loclString.split("/")[1];
      let formattedString =
        dat.getFullYear() +
        "-" +
        padWithLeadingZeros(dat.getMonth() + 1, 2) +
        "-" +
        padWithLeadingZeros(dat.getDate(), 2);
      last_week.push(formattedString);
      // arr.push(normalString)
    }

    console.log(this_week);

    let rev_arr = arr.reverse();

    setDateArray(rev_arr);
    setTestDateArray(test_arr);
    setLastMonth(last_month);
    setWeekLabel(label_week.reverse());
    setThisWeek(this_week);
    setLastWeek(last_week);
  }, []);

  console.log(thisWeek);

  const technicalChart = {
    series: [
      Math.ceil(
        100 -
        ((thisMonthData.openings - thisMonthData.openJobs) /
          thisMonthData.openings) *
        100
      ),
    ],
    options: {
      sparkline: {
        enabled: true,
      },
      chart: {
        height: 350,
        type: "radialBar",
      },

      plotOptions: {
        radialBar: {
          hollow: {
            size: "50%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      labels: [
        `${Math.ceil(
          ((thisMonthData.openings - thisMonthData.openJobs) /
            thisMonthData.openings) *
          100
        )}%`,
      ],
    },
  };

  const interviewed = {
    series: [
      Math.ceil(
        100 -
        ((thisMonthData.applicants - thisMonthData.applicantInterviewed) /
          thisMonthData.applicants) *
        100
      ),
    ],
    options: {
      sparkline: {
        enabled: true,
      },
      chart: {
        height: 350,
        type: "radialBar",
      },

      plotOptions: {
        radialBar: {
          hollow: {
            size: "50%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      labels: [
        `${Math.ceil(
          ((thisMonthData.applicants - thisMonthData.applicantInterviewed) /
            thisMonthData.applicants) *
          100
        )}%`,
      ],
    },
  };

  const shortlisted = {
    series: [
      Math.ceil(
        100 -
        ((thisMonthData.applicantInterviewed -
          thisMonthData.applicantShortlisted) /
          thisMonthData.applicantInterviewed) *
        100
      ),
    ],
    options: {
      sparkline: {
        enabled: true,
      },
      chart: {
        height: 350,
        type: "radialBar",
      },

      plotOptions: {
        radialBar: {
          hollow: {
            size: "50%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      labels: [
        `${Math.ceil(
          ((thisMonthData.applicantInterviewed -
            thisMonthData.applicantShortlisted) /
            thisMonthData.applicantInterviewed) *
          100
        )}%`,
      ],
    },
  };

  const series = [
    {
      name: "No of jobs",
      data: [ninetyDays, sixtyDays, thirtyDays, sevenDays],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        // horizontal: true,
        barHeight: "50%",
        // isFunnel: true,
        distributed: true,
      },
    },
    colors: ["#006FD6", "#4397E4", "#5BB5FF", "#94CBFF"],
    dataLabels: {
      enabled: false,

      dropShadow: {
        enabled: true,
      },
    },

    xaxis: {
      categories: ["60 - 90 days", "30 - 60 days", "7 - 30 days", "< 7 days"],
    },
    legend: {
      show: false,
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    axiosInstance.get(`/v2/user/getuser`)
      .then((res) => {
        console.log(res);
        setCompanyUuid(res.data.success.comapnyid);
        dispatch(updateCompanyId(res.data.success.comapnyid));
        // console.log(cid)
        // localStorage.setItem('cid',res.data.comapnyid)

        axios
          .get(`${server_API}/v2/company/get/${res.data.comapnyid}`)
          .then((response) => {
            if (response.data.departments) {
              setDept(response.data.departments);
              dispatch(updateSpecialTab(res.data.success.sourcing || false));
              dispatch(updateInternalSource(res.data.success.internal_source || false));
            } else {
              setDept([]);
            }
          })
          .catch((error) => {
            setDept([]);
            console.log(error);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (jobs.length > 0) {
      let sorted = jobs.map((m) => ({ ...m }));

      sorted = sorted.sort((a, b) => {
        return new Date(b.postdate) - new Date(a.postdate);
      });
      sorted = sorted.filter((f) => {
        return f.jobstatus != "Closed";
      });

      setLatestJobPosting(sorted.splice(0, 5));
    }
  }, [jobs]);

  console.log(thisWeek);

  useEffect(() => {
    if (jobs.length > 0 && testDateArray.length > 0 && thisWeek.length > 0) {
      console.log(jobs);
      let openingsThisMonth = 0;
      let openingsLastMonth = 0;
      let openJobs = 0;
      let lastMonthOpenJobs = 0;

      if (sortBy == "month") {
        jobs.map((j) => {
          if (testDateArray.includes(j.postdate.split("T")[0])) {
            openingsThisMonth = openingsThisMonth + 1;

            if (j.jobstatus.toLowerCase() == "open") {
              openJobs = openJobs + 1;
            }
          } else if (lastMonth.includes(j.postdate.split("T")[0])) {
            openingsLastMonth = openingsLastMonth + 1;
            if (j.jobstatus.toLowerCase() == "open") {
              lastMonthOpenJobs = lastMonthOpenJobs + 1;
            }
          }
        });
      } else if (sortBy == "week") {
        jobs.map((j) => {
          console.log(j);
          if (thisWeek.includes(j.postdate.split("T")[0])) {
            openingsThisMonth = openingsThisMonth + 1;

            if (j.jobstatus.toLowerCase() == "open") {
              openJobs = openJobs + 1;
            }
          } else if (lastWeek.includes(j.postdate.split("T")[0])) {
            openingsLastMonth = openingsLastMonth + 1;
            if (j.jobstatus.toLowerCase() == "open") {
              lastMonthOpenJobs = lastMonthOpenJobs + 1;
            }
          }
        });
      }
      console.log(openingsThisMonth);
      console.log(thisMonthData);
      setPreviousMonthData((previousMonthData) => ({
        ...previousMonthData,
        openings: openingsLastMonth,
        openJobs: lastMonthOpenJobs,
      }));
      setThisMonthData((thisMonthData) => ({
        ...thisMonthData,
        openings: openingsThisMonth,
        openJobs: openJobs,
      }));
      previousMonthData.openings = openingsLastMonth;
      previousMonthData.openJobs = openJobs;
      thisMonthData.openJobs = openJobs;
      thisMonthData.openings = openingsThisMonth;
    }
  }, [jobs, sortBy]);

  console.log(thisMonthData);

  useEffect(() => {
    if (applicants.length > 0 && testDateArray.length > 0) {
      let applicantThisMonthInterviewed = 0;
      let applicantThisMonthShortlisted = 0;
      let applicantLastMonthInterviewed = 0;
      let applicantLastMonthShortlisted = 0;
      let applicantsThisMonth = 0;
      let applicantsLastMonth = 0;
      let arr = [];
      let interviewedArr = [];
      var hash = new Map();
      let interviewedHash = new Map();
      const sorted = applicants.sort((a, b) => {
        return b.createdat - a.createdat;
      });
      sorted.forEach((s) => {
        hash.set(s.createdat.split("T")[0], 0);
        interviewedHash.set(s.createdat.split("T")[0], 0);
      });
      sorted.map((s) => {
        hash.set(
          s.createdat.split("T")[0],
          hash.get(s.createdat.split("T")[0]) + 1
        );
        if (s.aggregate > 0) {
          interviewedHash.set(
            s.createdat.split("T")[0],
            interviewedHash.get(s.createdat.split("T")[0]) + 1
          );
        }
      });
      // console.log(hash)

      if (sortBy == "week") {
        applicants.map((j) => {
          // console.log(j.createdat.split("T")[0])

          if (thisWeek.includes(j.createdat.split("T")[0])) {
            applicantsThisMonth = applicantsThisMonth + 1;
            if (j.aggregate > 0) {
              applicantThisMonthInterviewed = applicantThisMonthInterviewed + 1;
            } else if (j.aggregate > 0) {
              applicantThisMonthShortlisted = applicantThisMonthShortlisted + 1;
            }
          }
          if (lastWeek.includes(j.createdat.split("T")[0])) {
            applicantsLastMonth = applicantsLastMonth + 1;
            if (j.aggregate > 0) {
              applicantLastMonthInterviewed = applicantLastMonthInterviewed + 1;
            } else if (j.aggregate > 0) {
              applicantLastMonthShortlisted = applicantLastMonthShortlisted + 1;
            }
          }
        });
      } else if (sortBy == "month") {
        applicants.map((j) => {
          if (testDateArray.includes(j.createdat.split("T")[0])) {
            applicantsThisMonth = applicantsThisMonth + 1;
            if (j.aggregate > 0) {
              applicantThisMonthInterviewed = applicantThisMonthInterviewed + 1;
            } else if (j.aggregate > 0) {
              applicantThisMonthShortlisted = applicantThisMonthShortlisted + 1;
            }
          }
          if (lastMonth.includes(j.createdat.split("T")[0])) {
            applicantsLastMonth = applicantsLastMonth + 1;
            if (j.aggregate > 0) {
              applicantLastMonthInterviewed = applicantLastMonthInterviewed + 1;
            } else if (j.status == "Shortlisted") {
              applicantLastMonthShortlisted = applicantLastMonthShortlisted + 1;
            }
          }
        });
      }

      // console.log(testDateArray)
      // console.log(star_count)
      if (sortBy == "month") {
        testDateArray.map((m) => {
          if (hash.has(m)) {
            arr.push(hash.get(m));
          } else {
            arr.push(0);
          }
          if (interviewedHash.has(m)) {
            interviewedArr.push(interviewedHash.get(m));
          } else {
            interviewedArr.push(0);
          }
        });
      } else if (sortBy == "week") {
        thisWeek.map((m) => {
          if (hash.has(m)) {
            arr.push(hash.get(m));
          } else {
            arr.push(0);
          }
          if (interviewedHash.has(m)) {
            interviewedArr.push(interviewedHash.get(m));
          } else {
            interviewedArr.push(0);
          }
        });
      }
      setApplicationsMonthly(arr.reverse());
      setInterviewedMonthly(interviewedArr.reverse());
      setThisMonthData({
        ...thisMonthData,
        applicantInterviewed: applicantThisMonthInterviewed,
        applicantShortlisted: applicantThisMonthShortlisted,
        applicants: applicantsThisMonth,
      });
      setPreviousMonthData({
        ...previousMonthData,
        applicantInterviewed: applicantLastMonthInterviewed,
        applicantShortlisted: applicantLastMonthShortlisted,
        applicants: applicantsLastMonth,
      });
    }
  }, [applicants, sortBy]);

  useEffect(() => {
    if (applicants.length > 0) {
      let star_count = [0, 0, 0, 0, 0];
      let sum = 0;
      applicants.map((j) => {
        if (j.rating > 0) {
          star_count[j.rating - 1] += 1;
        }
      });
      star_count.map((m) => {
        sum += m;
      });
      setStars(star_count);
      setSumStars(sum);
    }
  }, [applicants]);

  useEffect(() => {
    if (allJobs.length > 0) {
      const j = allJobs.filter((s) => {
        if (s.saveas == "publish") {
          return s;
        }
      });
      setJobs(j);
    } else {
      setJobs([]);
    }
  }, [allJobs]);
  useEffect(() => {
    if (companyUuid.length > 0) {
      axios
        .get(`${server_API}/v2/job/getjobs/${companyUuid}`)
        .then((res) => {
          // setJobs(res.data)
          setAllJobs(res.data);
        })
        .catch((err) => {
          console.log(err);
          setAllJobs([]);
        });
      axios
        .get(`${server_API}/v2/applicant/getall/${companyUuid}`)
        .then((res) => {
          // console.log(res)
          setApplicants(res.data);
        })
        .catch((err) => {
          // console.log(err)
          setApplicants([]);
        });

      axios
        .get(`${server_API}/v2/interview/company/${companyUuid}`)
        .then((res) => {
          // console.log(res)
          setInterviews(res.data, "interviews");
        })
        .catch((err) => {
          // console.log(err)
          setInterviews([]);
        });
    }
  }, [companyUuid]);

  useEffect(() => {
    if (interviews.length > 0) {
      const inter = interviews.filter((f) => {
        if (f.chunk.length >= 6) {
          return f;
        }
      });
      setActiveInterviews(inter);
    }
  }, [interviews]);

  // useEffect(()=>{
  //   if((dept.length>0)&&(jobs.length>0)&&(sFlag == false)){
  //     dept.map((d,i)=>{
  //       var count = 0
  //       jobs.map((j,i)=>{
  //         if(j.department == d){
  //           count = count +1;
  //         }
  //       })
  //       data.push(count)
  //     })
  //     setSFlag(true)
  //   }

  // },[jobs,dept])
  const labels = [
    "Jan",
    "Feb",
    "March",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const label_data = [];

  function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }

  console.log(data);
  useEffect(() => {
    const app = [];
    const interview = [];
    const job = [];
    if (jobs.length > 0 && flag == false) {
      // for(var i = 0; i<6; i++){
      //   label_data.push(labels[i])
      //   app.push(0)
      //   interview.push(0)
      //   job.push(0)
      // }
      setTotalApplication(app);
      setEva(interview);
      setLabel(removeDuplicates(label_data));
      setgraphJobs(job);
      var openJob = 0;
      var closeJobs = 0;
      var pauseJobs = 0;
      var seven = 0;
      var thirty = 0;
      var sixty = 0;
      var ninety = 0;
      console.log(jobs);
      const updatedArea = [...submissions];
      const updatedEvaluations = [...evaluated];
      jobs.map((j) => {
        const index = parseInt(j.createdat.split("-")[1]) - 1;
        updatedArea[index] = updatedArea[index] + parseInt(j.totalapplication);
        updatedEvaluations[index] =
          updatedEvaluations[index] + parseInt(j.interviewed);
        // console.log(parseInt(j.selectedapplication))
        if (j.jobstatus.toLowerCase() == "open") {
          openJob = openJob + 1;
          // setOpenJobs(()=>openJobs+1)
          const postedDate = new Date(j.postdate.split("T")[0]);
          const td = todayDate.getTime() - postedDate.getTime();
          const days_difference = Math.ceil(td / (1000 * 60 * 60 * 24));
          console.log(days_difference);
          if (days_difference <= 7) {
            seven = seven + 1;
          }
          if (days_difference <= 30 && days_difference > 7) {
            thirty = thirty + 1;
          }
          if (days_difference <= 60 && days_difference > 30) {
            sixty = sixty + 1;
          }
          if (days_difference <= 90 && days_difference >= 60) {
            ninety = ninety + 1;
          }
          setSevenDays(seven);
          setThirtyDays(thirty);
          setSixtyDays(sixty);
          setNinetyDays(ninety);
        } else if (j.jobstatus.toLowerCase() == "closed") {
          closeJobs = closeJobs + 1;
        } else if (j.jobstatus.toLowerCase() == "paused") {
          pauseJobs = pauseJobs + 1;
        }
      });
      setOpenJobs(openJob);
      setPausedJobs(pauseJobs);
      setClosedJobs(closeJobs);
      setFlag(true);
      setSubmissions(updatedArea);
      setEvaluated(updatedEvaluations);
      console.log(submissions);
    }
  }, [jobs]);

  const myPlugin = {
    id: "customShadow",
    beforeDraw: (chart) => {
      const ctx = chart.ctx;
      ctx.save();

      const originalLineDraw = ctx.stroke;
      ctx.stroke = function () {
        ctx.save();
        ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
        ctx.shadowBlur = 10;
        ctx.shadowOffsetX = 4;
        ctx.shadowOffsetY = 4;
        originalLineDraw.apply(this, arguments);
        ctx.restore();
      };
    },
  };

  function monthDiff(dateFrom, dateTo) {
    return (
      dateTo.getMonth() -
      dateFrom.getMonth() +
      12 * (dateTo.getFullYear() - dateFrom.getFullYear())
    );
  }

  var submissions_object = {};
  labels.forEach((label, i) => (submissions_object[label] = submissions[i]));

  var evaluated_object = {};
  labels.forEach((label, i) => (evaluated_object[label] = evaluated[i]));

  // console.log(submissions_object)

  return (
    <div>
      <div className="bg-[#f0f4fc] min-h-screen">
        <div className="md:px-10 pt-5 p-3">
          <div className="flex items-center justify-between">
            <p className="text-2xl font-semibold">Dashboard</p>
            <div className="relative">
              <button
                className={
                  !open
                    ? "py-1 h-full  bg-transparent border-2 text-[#148EFF]  border-[#148EFF]  bg-[#148EFF] font-semibold px-4 rounded-lg"
                    : "py-1 h-full  bg-transparent border-2 border-[#148EFF]  text-[#148EFF]  font-semibold px-4 rounded-t-lg"
                }
                onClick={() => {
                  setOpen(!open);
                }}
              >
                <div className="flex items-center justify-between">
                  {sortBy == "week" ? "Last 7 days" : "Last 30 days"}
                  <img src={arrow} className="-rotate-90 ml-4 h-2"></img>
                </div>
              </button>
              {open && (
                <div className="flex flex-col bg-[#148EFF]  absolute w-full text-white rounded-b-lg">
                  <button
                    onClick={() => {
                      if (sortBy == "week") {
                        setSortBy("month");
                        setOpen(false);
                      } else if (sortBy == "month") {
                        setSortBy("week");
                        setOpen(false);
                      }
                    }}
                  >
                    <div className=" text-left space-x-1 py-3 px-4">
                      <p>
                        {sortBy == "week" && "Last 30 days"}
                        {sortBy == "month" && "Last 7 days"}
                      </p>
                    </div>
                  </button>

                  {/* <button onClick={()=>{setUpload(true)}}>
            <div className="flex items-center space-x-4 py-3 px-3">
              <img src={page} className="h-5"></img>
              <p>Upload</p>
            </div>
          </button> */}
                </div>
              )}
            </div>
          </div>
          <div className="md:grid space-y-4 md:space-y-0 md:grid-cols-5 my-5 gap-4">
            <div className="bg-white p-6 rounded-xl shadow-xl">
              <div className=" justify-between items-center ">
                <div>
                  <p className="text-base font-semibold">
                    Total positions posted
                  </p>
                  <p className="text-2xl font-semibold">
                    {thisMonthData.openings}
                  </p>
                </div>
              </div>
              {thisMonthData.openings - previousMonthData.openings > 0 ? (
                <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                  <img src={increase} className="h-3"></img>
                  <p>Average increase</p>
                  <p>
                    {
                      ~~Math.ceil(
                        ((thisMonthData.openings - previousMonthData.openings) /
                          thisMonthData.openings) *
                        100
                      )
                    }
                    %
                  </p>
                </div>
              ) : (
                <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                  <img src={decrease} className="h-3"></img>
                  <p>Average decrease</p>
                  <p>
                    {
                      ~~Math.ceil(
                        (-(
                          thisMonthData.openings - previousMonthData.openings
                        ) /
                          thisMonthData.openings) *
                        100
                      )
                    }
                    %
                  </p>
                </div>
              )}
            </div>

            <div className="bg-white p-6  rounded-xl shadow-xl">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-base font-semibold">Open Jobs</p>
                  <p className="text-2xl font-semibold">
                    {thisMonthData.openJobs}
                  </p>
                </div>
                <div className="relative w-1/3 -mt-3">
                  <ReactApexChart
                    options={technicalChart.options}
                    series={technicalChart.series}
                    type="radialBar"
                    height={120}
                    className="text-xs mx-auto "
                  />
                  <p className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2  text-sm z-20">{`${~~Math.ceil(
                    100 -
                    ((thisMonthData.openings - thisMonthData.openJobs) /
                      thisMonthData.openings) *
                    100
                  )}%`}</p>
                </div>
              </div>
              <div className="-mt-8">
                {thisMonthData.openJobs - previousMonthData.openJobs > 0 ? (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={increase} className="h-3"></img>

                    <p>
                      {
                        ~~Math.ceil(
                          ((thisMonthData.openJobs -
                            previousMonthData.openJobs) /
                            thisMonthData.openJobs) *
                          100
                        )
                      }
                      % increase
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={decrease} className="h-3"></img>

                    <p>
                      {
                        ~~Math.ceil(
                          (-(
                            thisMonthData.openJobs - previousMonthData.openJobs
                          ) /
                            thisMonthData.openJobs) *
                          100
                        )
                      }
                      % decrease
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-xl">
              <div className="flex justify-between items-center ">
                <div>
                  <p className="text-base font-semibold">Total Applications</p>
                  <p className="text-2xl font-semibold">
                    {thisMonthData.applicants}
                  </p>
                </div>
              </div>

              {/* {applicants.length}/{jobs.length} */}
              {/* Total interviews selected in company  */}
              <div className="">
                {thisMonthData.applicants - previousMonthData.applicants > 0 ? (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={increase} className="h-3"></img>
                    <p>Average increase</p>
                    <p>
                      {
                        ~~Math.ceil(
                          ((thisMonthData.applicants -
                            previousMonthData.applicants) /
                            thisMonthData.applicants) *
                          100
                        )
                      }
                      %
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={decrease} className="h-3"></img>
                    <p>Average decrease</p>
                    <p>
                      {
                        ~~Math.ceil(
                          (-(
                            thisMonthData.applicants -
                            previousMonthData.applicants
                          ) /
                            thisMonthData.applicants) *
                          100
                        )
                      }
                      %
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="bg-white p-6  rounded-xl shadow-xl">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-base font-semibold">Interviewed</p>
                  <p className="text-2xl font-semibold">
                    {thisMonthData.applicantInterviewed}
                  </p>
                </div>
                <div className="relative w-1/3 -mt-3">
                  <ReactApexChart
                    options={interviewed.options}
                    series={interviewed.series}
                    type="radialBar"
                    height={120}
                    className="text-sm mx-auto "
                  />
                  <p className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2  text-sm z-20">{`${~~Math.ceil(
                    100 -
                    ((thisMonthData.applicants -
                      thisMonthData.applicantInterviewed) /
                      thisMonthData.applicants) *
                    100
                  )}%`}</p>
                </div>
              </div>
              <div className="-mt-8">
                {thisMonthData.applicantInterviewed -
                  previousMonthData.applicantInterviewed >
                  0 ? (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={increase} className="h-3"></img>

                    <p>
                      {
                        ~~Math.ceil(
                          ((thisMonthData.applicantInterviewed -
                            previousMonthData.applicantInterviewed) /
                            thisMonthData.applicantInterviewed) *
                          100
                        )
                      }
                      % increase
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={decrease} className="h-3"></img>

                    <p>
                      {
                        ~~Math.ceil(
                          (-(
                            thisMonthData.applicantInterviewed -
                            previousMonthData.applicantInterviewed
                          ) /
                            thisMonthData.applicantInterviewed) *
                          100
                        )
                      }
                      % decrease
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="bg-white p-6  rounded-xl shadow-xl">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-base font-semibold">Shortlisted</p>
                  <p className="text-2xl font-semibold">
                    {thisMonthData.applicantShortlisted}
                  </p>
                </div>
                <div className="relative w-1/3 -mt-3">
                  <ReactApexChart
                    options={shortlisted.options}
                    series={shortlisted.series}
                    type="radialBar"
                    height={120}
                    className="text-sm mx-auto "
                  />
                  <p className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2  text-sm z-20">{`${~~Math.ceil(
                    100 -
                    ((thisMonthData.applicantInterviewed -
                      thisMonthData.applicantShortlisted) /
                      thisMonthData.applicantInterviewed) *
                    100
                  )}%`}</p>
                </div>
              </div>
              <div className="-mt-8">
                {thisMonthData.applicantShortlisted -
                  previousMonthData.applicantShortlisted >
                  0 ? (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={increase} className="h-3"></img>
                    <p>Average increase</p>
                    <p>
                      {
                        ~~Math.ceil(
                          ((thisMonthData.applicantShortlisted -
                            previousMonthData.applicantShortlisted) /
                            thisMonthData.applicantShortlisted) *
                          100
                        )
                      }
                      %
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center text-[#8F94A1] mt-10 text-sm space-x-2">
                    <img src={decrease} className="h-3"></img>
                    <p>Average decrease</p>
                    <p>
                      {
                        ~~Math.ceil(
                          (-(
                            thisMonthData.applicantShortlisted -
                            previousMonthData.applicantShortlisted
                          ) /
                            thisMonthData.applicantShortlisted) *
                          100
                        )
                      }
                      %
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="mt-6 grid  bg-white rounded-xl p-6 relative">
            <p className="font-semibold text-lg">Job Posting</p>

            {jobs.length == 0 && (
              <div className="absolute bg-white -translate-x-1/2 -translate-y-1/2 text-center p-4 rounded-xl border shadow-2xl left-1/2 top-1/2">
                <p>You do not have any data</p>
                <p>Please post some jobs</p>
              </div>
            )}
            {dateArray.length > 0 && (
              <ReactApexChart
                options={mixedChart.options}
                series={mixedChart.series}
                type="bar"
                height={350}
              />
            )}
          </div>
          <div className="grid grid-cols-2 gap-4 mt-6">
            <div className="bg-white rounded-xl p-6">
              <p className="text-xl font-semibold">Aging</p>
              <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height={350}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 ">
              <div className="bg-[#E15C44] text-white p-6 rounded-xl">
                <p className="text-xl font-semibold">Latest Job Posting</p>
                <div className="flex flex-col justify-start py-8 h-full space-y-12">
                  {latestJobPosting.map((m) => {
                    return (
                      <Link to="/jobs/candidates" state={{ id: m.uuid }}>
                        <div className="flex justify-between items-center hover:scale-105 transition-all border-b pb-2  font-poppins text-sm border-[#FFFFFF99]">
                          <p>{m.profilename}</p>
                          <p>
                            {new Date(m.postdate.split("T")[0]).getDate()}{" "}
                            {
                              labels[
                              new Date(m.postdate.split("T")[0]).getMonth()
                              ]
                            }
                          </p>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
              <div className="bg-white text-black p-6 rounded-xl">
                <p className="font-semibold text-xl">
                  Feedback From Candidates
                </p>
                <div className="flex flex-col h-full  justify-between">
                  <div className="flex justify-between border-b-4 border-dotted -ml-3 items-center">
                    <ReactStars
                      count={5}
                      className="text-center  rounded-xl px-3"
                      value={5}
                      isHalf={false}
                      half={false}
                      edit={false}
                      size={40}
                      color1={"#FFFFFF"}
                    />
                    <p>{~~Math.ceil((stars[4] / sumStars) * 100)}%</p>
                  </div>
                  <div className="flex justify-between border-b-4 border-dotted -ml-3 items-center">
                    <ReactStars
                      count={5}
                      className="text-center  rounded-xl px-3"
                      value={4}
                      isHalf={false}
                      half={false}
                      edit={false}
                      size={40}
                      color1={"#FFFFFF"}
                    />
                    <p>{~~Math.ceil((stars[3] / sumStars) * 100)}%</p>
                  </div>
                  <div className="flex justify-between border-b-4 border-dotted -ml-3 items-center">
                    <ReactStars
                      count={5}
                      className="text-center  rounded-xl px-3"
                      value={3}
                      isHalf={false}
                      half={false}
                      edit={false}
                      size={40}
                      color1={"#FFFFFF"}
                    />
                    <p>{~~Math.ceil((stars[2] / sumStars) * 100)}%</p>
                  </div>
                  <div className="flex justify-between border-b-4 border-dotted -ml-3 items-center">
                    <ReactStars
                      count={5}
                      className="text-center  rounded-xl px-3"
                      value={2}
                      isHalf={false}
                      half={false}
                      edit={false}
                      size={40}
                      color1={"#FFFFFF"}
                    />
                    <p>{~~Math.ceil((stars[1] / sumStars) * 100)}%</p>
                  </div>
                  <div className="flex justify-between mb-4 -ml-3 items-center">
                    <ReactStars
                      count={5}
                      className="text-center  rounded-xl px-3"
                      value={1}
                      isHalf={false}
                      half={false}
                      edit={false}
                      size={40}
                      color1={"#FFFFFF"}
                    />
                    <p>{~~Math.ceil((stars[0] / sumStars) * 100)}%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
